/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { xs_isMobile } from '..';
import { useXRouterUrl } from './seo/xrouter/XRouterLink';

export default function SocialButtons(props) {
    const url = `https://${window.location.hostname}${useXRouterUrl(props.url,props.urlData)}`;
    const text = `${props.message} ${window.encodeURIComponent(url)}`.replace(/ /g, '%20');
    const whatsappUrl = xs_isMobile ? `whatsapp://send?text=${text}` : `https://web.whatsapp.com/send?text=${text}`;
    const telegramUrl = `https://t.me/share/url?url=${url}&text=${props.message}`;

    return (
        <>
            <div id="xs-whatsapp-share-button" className="h-[24px] w-[24px] flex items-center justify-center">
                <a href={whatsappUrl}>
                    <img height="20px" width="20px" src={`${process.env.PUBLIC_URL}/assets/images/whatsapp.svg`} alt="Whatsapp share button" />
                </a>
            </div>
            <div id="xs-telegram-share-button" className="h-[24px] w-[24px] flex items-center justify-center">
                <a href={telegramUrl}>
                    <img height="20px" width="20px" src={`${process.env.PUBLIC_URL}/assets/images/telegram.svg`} alt="Telegram share button" />
                </a>
            </div>
        </>
    );
}
